import { render, staticRenderFns } from "./image-selector.vue?vue&type=template&id=57c62b16&scoped=true&"
import script from "./image-selector.vue?vue&type=script&lang=js&"
export * from "./image-selector.vue?vue&type=script&lang=js&"
import style0 from "./image-selector.vue?vue&type=style&index=0&id=57c62b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c62b16",
  null
  
)

export default component.exports